import { useHasAccess } from '@/hooks/user';
import Account from '@/icons/account.svg';
import Contact from '@/icons/contact.svg';
import Documents from '@/icons/documents.svg';
import NewDocument from '@/icons/new-document.svg';
import Payments from '@/icons/payments.svg';
import Users from '@/icons/users.svg';
import { VIEWS_NAMES } from '@/pages/Collaborators/CollaboratosModal/constants';
import routes from '@/routes';

const sitemap = [
	{
		links: [
			{
				icon: NewDocument,
				text: 'navigation.newDocument',
				to: routes.newDocument
			},
			{
				icon: Documents,
				text: 'navigation.myDocuments',
				to: routes.myDocuments,
				view: VIEWS_NAMES.MY_PDFS
			},
			{
				icon: Users,
				text: 'navigation.users',
				to: routes.users
			},
			{
				icon: Payments,
				text: 'navigation.billing',
				to: routes.billing,
				view: VIEWS_NAMES.BILLING
			}
		]
	},
	{
		links: [
			{
				icon: Contact,
				text: 'navigation.contact',
				to: routes.contact
			},
			{
				icon: Account,
				text: 'navigation.myAccount',
				to: routes.myAccount
			}
		]
	}
];

const getSitemap = (isCollaborator, isExtendedCollaborator) => {
	const hasAccess = useHasAccess();

	return isCollaborator || isExtendedCollaborator
		? sitemap.map(({ links }) => ({
				links: links.filter(({ to, view }) => {
					if (to === routes.users) {
						return false;
					}
					return view ? hasAccess(view) : true;
				})
			}))
		: sitemap;
};

export default getSitemap;
